import { TooltipDirection } from '@anm/components/Tooltip';
import useHover from '@anm/hooks/useHover';
import { useEffect, useState } from 'react';

const HEADER_WRAPPER_HEIGHT = 143;
const MAX_OFFSET = HEADER_WRAPPER_HEIGHT + 100;

const useDirection = () => {
  const [hoverRef, isHovered] = useHover<HTMLDivElement>();
  const [direction, setDirection] = useState<TooltipDirection>();

  useEffect(() => {
    if (!isHovered || !hoverRef.current) return;

    const direction = hoverRef.current?.getBoundingClientRect().y > MAX_OFFSET ? 'to-top' : 'to-bottom';
    setDirection(direction);
  }, [isHovered, hoverRef.current]);

  return [direction, hoverRef] as const;
};

export default useDirection;
